import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableGiftcardPurchase',
  initialState: false,
  reducers: {
    setEnableGiftcardPurchase(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableGiftcardPurchase } = slice.actions;

export default slice.reducer;
